import { render, staticRenderFns } from "./ChatPropertyCards.vue?vue&type=template&id=88fa4a92&scoped=true"
import script from "./ChatPropertyCards.vue?vue&type=script&lang=js"
export * from "./ChatPropertyCards.vue?vue&type=script&lang=js"
import style0 from "./ChatPropertyCards.vue?vue&type=style&index=0&id=88fa4a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fa4a92",
  null
  
)

export default component.exports